import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {providePrimeNG} from 'primeng/config';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {httpAuthInterceptor} from '../../sdk/src/interceptors/http-auth.interceptor';
import {MessageService} from 'primeng/api';
import {ToastModule} from 'primeng/toast';
import {OrangePrimeNGTheme} from '../../sdk/src/orange-primeng.theme';
import {OO8_EVENT_SERVICE_CONFIG} from '../../sdk/src/services/oo8-event.service';
import {environment} from '../environments/environment';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: OO8_EVENT_SERVICE_CONFIG,
            useValue: {
                serverUrl: environment.oo8EventBaseUrl,
                domain: 'oo8-cpm'
            }
        },
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: OrangePrimeNGTheme,
                options: {
                    prefix: 'p',
                    darkModeSelector: '.app-dark',
                    cssLayer: false
                }
            },
            ripple: true,

            inputVariant: 'filled'
        }),
        provideHttpClient(withInterceptors([httpAuthInterceptor /*, queryPaginatorInterceptor*/])),
        MessageService,
        ToastModule
    ]
};
